const DEFAULT_TIME_ZONE = "America/Santiago";

function getServerTimeZone() {
	if (typeof window === "undefined") return DEFAULT_TIME_ZONE;

	const savedTimeZone = localStorage.getItem("somnus_server_tz");
	if (!savedTimeZone) return DEFAULT_TIME_ZONE;

	return savedTimeZone.trim() || DEFAULT_TIME_ZONE;
}

function getDateFormatter() {
	return new Intl.DateTimeFormat("es-CL", {
		timeZone: getServerTimeZone(),
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	});
}

function getTimeFormatter() {
	return new Intl.DateTimeFormat("es-CL", {
		timeZone: getServerTimeZone(),
		hour: "2-digit",
		minute: "2-digit",
	});
}

function parseDateValue(value) {
	if (!value) return null;

	const rawValue = String(value).trim();
	const dateOnlyMatch = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
	if (dateOnlyMatch) {
		const year = Number(dateOnlyMatch[1]);
		const month = Number(dateOnlyMatch[2]);
		const day = Number(dateOnlyMatch[3]);

		// Usamos mediodía UTC para evitar que el huso horario de Chile retroceda el día.
		return new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
	}

	const parsedDate = new Date(rawValue);
	return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
}

function parseServerLocalParts(value) {
	if (!value) return null;

	const rawValue = String(value).trim();
	// eslint-disable-next-line security/detect-unsafe-regex
	const match = rawValue.match(
		/^(\d{2})[/-](\d{2})[/-](\d{4})(?:\s+(\d{2}):(\d{2})(?::\d{2}(?:\.\d{1,6})?)?)?$/,
	);
	if (!match) return null;

	return {
		day: match[1],
		month: match[2],
		year: match[3],
		hour: match[4] ?? null,
		minute: match[5] ?? null,
	};
}

/**
 * Formatea un texto de fecha al formato chileno exacto DD-MM-YYYY.
 */
export function formatDate(dateString) {
	const serverLocalParts = parseServerLocalParts(dateString);
	if (serverLocalParts) {
		return `${serverLocalParts.day}-${serverLocalParts.month}-${serverLocalParts.year}`;
	}

	const date = parseDateValue(dateString);
	if (!date) return "";

	const parts = getDateFormatter().formatToParts(date);
	const day = parts.find((part) => part.type === "day")?.value ?? "";
	const month = parts.find((part) => part.type === "month")?.value ?? "";
	const year = parts.find((part) => part.type === "year")?.value ?? "";

	return day && month && year ? `${day}-${month}-${year}` : "";
}

/**
 * Formatea fecha y hora al formato chileno DD-MM-YYYY HH:mm.
 */
export function formatDateTime(dateString) {
	const serverLocalParts = parseServerLocalParts(dateString);
	if (serverLocalParts) {
		const datePart = `${serverLocalParts.day}-${serverLocalParts.month}-${serverLocalParts.year}`;
		if (serverLocalParts.hour && serverLocalParts.minute) {
			return `${datePart} ${serverLocalParts.hour}:${serverLocalParts.minute}`;
		}
		return datePart;
	}

	const date = parseDateValue(dateString);
	if (!date) return "";

	return `${formatDate(dateString)} ${getTimeFormatter().format(date)}`;
}
